import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-techsure-lms',
  templateUrl: './techsure-lms.component.html'
})
export class TechsureLmsComponent implements OnInit, OnDestroy {
  currentYear: number = new Date().getFullYear();
  showTitleSection: boolean = true;
  isDropdownOpen: boolean = false;
  private routerSub!: Subscription;

  constructor(private commonService: CommonService, private router: Router) {}

  ngOnInit(): void {
    this.checkRoute(this.router.url);

    this.routerSub = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.checkRoute(event.urlAfterRedirects);
    });
  }

  checkRoute(url: string): void {
    // Hide the tabs & title if the URL contains take, results, or the new watch route
    if (url.includes('/take/') || url.includes('/results/') || url.includes('/watch')) {
      this.showTitleSection = false;
    } else {
      this.showTitleSection = true;
    }
  }

  toggleDropdown(event: Event): void {
    event.stopPropagation();
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.isDropdownOpen) {
      this.isDropdownOpen = false;
    }
  }

  logout(): void {
    this.isDropdownOpen = false;
    this.commonService.logout();
  }

  ngOnDestroy(): void {
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
  }
}